// Лимит записей в истории
export const LIMIT_HISTORY = "limit=0";

// Лимит записей на странице
export const LIMIT = 12;

// Лимит записей для прицепов
export const TRAILER_LIMIT = 3;

// Лимит записей для контейнеров
export const CONTAINER_LIMIT = 3;

// Лимит записей для фотофиксации
export const PHOTO_RECORDINGS_LIMIT = 5;

// Время бездействия пользователя
export const TIMEOUT = 30 * 60 * 1000;

// Меню
export const INCLUDED_MENU_NAMES = [
  'transit-control-system-root',
  'transit-control-system-transit-declaration',
  "registration-root",
  'registration-image-root',
  'registration-vgk-root',
  'registration-idk-root',
  'registration-rpm-root',
  'registration-root-registration-card',
  'registration-root-photo-recording',
  'registration-root-vgk',
  'registration-root-idk-inspection',
  'registration-root-rpm-event',
  'customs-control',
  'act-customs-inspection',
  'dictionary-event-log-customs-inspection',
  'preliminary-information-root',
  'preliminary-information-pi-request',
  'preliminary-information-pre-info',
  'temporary-import-export-root',
  'temporary-import-export-citd-root',
  'temporary-import-tslp-export-root',
  'temporary-import-export-root-temporary-import-export-citd',
  'temporary-import-export-root-temporary-import-export-tslp',
];

export const RESTRICTED_DEPARTMENT_CODES = [
  '41750002',
  '41750003',
  '41731105',
];

export const IRKESHTAM = ['41762104'];

export const DOSTUK_KEN_SAI = [
  '41762101',
  '41731105',
]
